export const convertNumberToHex = (value) => {
  const hexString = value.toString(16).padStart(4, "0").toUpperCase();
  return hexString.substring(0, 2) + "-" + hexString.substring(2, 4);
};

export const convertHexToNumber = (value) => {
  return parseInt(value.replace("-", ""), 16);
};
